<template>
    <div class="">
        <div class="container">

            <div class="t-flex-grid">
                <div class="t-flex-grid__item c-2d__perspective" id="perspective">

                    <canvas v-if="touch" class="c-2d"></canvas>
                    <div v-if="touch" class="c-2d__main-image"></div>
                    <canvas v-if="!touch" id="canvas" class="c-2d"></canvas>
                    <div v-if="!touch" class="c-2d--dist" id="overlay"></div>

                    <svg class="c-2d__svg c-2d__svg--right" version="1.1" baseProfile="tiny" id="svg-circle-outer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" width="561px" height="561px" viewBox="0 0 560 560" xml:space="preserve">
                        <circle class="c-2d__loader" fill="none" cx="280" cy="280" r="280" stroke-dashoffset="1759.292" stroke-dasharray="1759.292" stroke="#fff" stroke-width="1"/>
                    </svg>
                    <svg class="c-2d__svg c-2d__svg--left" version="1.1" baseProfile="tiny" id="svg-circle-outer-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" width="561px" height="561px" viewBox="0 0 560 560" xml:space="preserve">
                        <circle class="c-2d__loader" fill="none" cx="280" cy="280" r="280" stroke-dashoffset="1759.292" stroke-dasharray="1759.292" stroke="#fff" stroke-width="1"/>
                    </svg>
                    <svg class="c-2d__svg c-2d__svg--inner c-2d__svg--right" version="1.1" baseProfile="tiny" id="svg-circle-inner" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" width="561px" height="561px" viewBox="0 0 560 560" xml:space="preserve">
                        <circle class="c-2d__loader" fill="none" cx="280" cy="280" r="280" stroke-dashoffset="1759.292" stroke-dasharray="1759.292" stroke="#fff" stroke-width="1"/>
                    </svg>
                    <svg class="c-2d__svg c-2d__svg--inner c-2d__svg--left" version="1.1" baseProfile="tiny" id="svg-circle-inner-left" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px" y="0px" width="561px" height="561px" viewBox="0 0 560 560" xml:space="preserve">
                        <circle class="c-2d__loader" fill="none" cx="280" cy="280" r="280" stroke-dashoffset="1759.292" stroke-dasharray="1759.292" stroke="#fff" stroke-width="1"/>
                    </svg>
                    <span class="c-2d__mask"></span>
                    <video id="video1" muted="muted" loop autoplay class="c-2d__video">
                        <source src="assets\videos\Comp 2_4.webm"  type="video/webm">
                    </video>

                    <span class="c-2d__page-btns">
                        <button v-on:click="goPrevious()" class="c-2d__page-btn c-2d__page-btn--prev">
                            <svg class="c-2d__svg-page" version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px" y="0px" width="39px" height="39px" viewBox="0 0 36 36" xml:space="preserve">
                                <circle class="c-2d__page-circle" fill="none" cx="18" cy="17" r="18" stroke-dashoffset="113.01" stroke-dasharray="113.01" stroke="#fff" stroke-width="1"/>
                            </svg>
                        </button>
                        <button v-on:click="goNext($event)" class="c-2d__page-btn c-2d__page-btn--next">
                            <svg class="c-2d__svg-page" version="1.1" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px" y="0px" width="39px" height="39px" viewBox="0 0 36 36" xml:space="preserve">
                                <circle class="c-2d__page-circle" fill="none" cx="18" cy="17" r="18" stroke-dashoffset="113.01" stroke-dasharray="113.01" stroke="#fff" stroke-width="1"/>
                            </svg>
                        </button>
                    </span>
                </div>
                <!-- <div class="t-flex-grid__item">
                    <span class="t-flex-grid__mask t-flex-grid__mask-white"></span>
                    <h1 class="t-flex-grid__title">Blah</h1>
                    <canvas id="canvas" class="c-2d"></canvas>
                </div>
                <div class="t-flex-grid__item">
                    <span class="t-flex-grid__mask t-flex-grid__mask-white"></span>
                    <h1 class="t-flex-grid__title">Blah</h1>
                    <canvas id="canvas" class="c-2d"></canvas>
                </div> -->
                <div class="c-2d__pagination">
                    <span class="c-2d__page-number c-2d__page-number--edge" v-bind:class="{'c-2d__page-number--active':currentIndex == 2, 'c-2d__page-number--inactive': currentIndex != 2}"></span>
                    <span class="c-2d__page-number c-2d__page-number--center" v-bind:class="{'c-2d__page-number--active':currentIndex == 0, 'c-2d__page-number--inactive': currentIndex != 0}"></span>
                    <span class="c-2d__page-number c-2d__page-number--edge" v-bind:class="{'c-2d__page-number--active':currentIndex == 1, 'c-2d__page-number--inactive': currentIndex != 1}"></span>
                </div>
            </div>
            <router-link to="/shop" class="t-flex-grid__title">EXPLORE OUR COLLECTION</router-link>

            <span class="t-flex-grid__btn-mask"></span>

            <script id="vs" type="f">
                attribute vec2 position;
                attribute vec2 texcoord;

                uniform mat3 u_matrix;

                varying vec2 v_texcoord;

                void main() {
                    gl_Position = vec4(u_matrix * vec3(position, 1), 1);
                    v_texcoord = texcoord;
                }
            </script>

            <!-- fragment shader -->
            <script id="fs" type="f">
                precision mediump float;

                uniform vec2 u_mouse;

                uniform sampler2D u_originalImage;
                uniform sampler2D u_mapImage;

                varying vec2 v_texcoord;

                void main() {
                    vec4 depthDistortion = texture2D(u_mapImage, v_texcoord);
                    float parallaxMult = depthDistortion.r;

                    vec2 parallax = (u_mouse) * parallaxMult;

                    vec4 original = texture2D(u_originalImage, (v_texcoord + parallax));
                    gl_FragColor = original;
                }
            </script>
        </div>
    </div>
</template>

<script>
import * as THREE from './vendor/three.js'
import * as twgl from './vendor/twgl-full.js'
import * as m3 from './vendor/m3.js'
// import ThreeD from '../components/Products.vue';
// import { Vue } from 'vue/types/vue';
const ringImagesAll = {
    LG:[
        {
            col:"/src/assets/3dTestStuff/Egypt-Colour-LG",
            z:"/src/assets/3dTestStuff/Egypt-Z-LG"
        }, // IF YOU CHANGE PATH OF THESE DONT FORGET LINE 732
        {
            col:"/src/assets/3dTestStuff/Celtic-Colour-LG",
            z:"/src/assets/3dTestStuff/Celtic-Z-LG"
        },
        {
            col:"/src/assets/3dTestStuff/Ornate-Colour-LG",
            z:"/src/assets/3dTestStuff/Ornate-Z-LG"
        }
    ],
    MD: [
        {
            col:"/src/assets/3dTestStuff/Egypt-Colour-MD",
            z:"/src/assets/3dTestStuff/Egypt-z-MD",
        },
        {
            col:"/src/assets/3dTestStuff/Celtic-Colour-MD",
            z:"/src/assets/3dTestStuff/Celtic-z-MD",
        },
        {
            col:"/src/assets/3dTestStuff/Ornate-Colour-MD",
            z:"/src/assets/3dTestStuff/Ornate-z-MD",
        }
    ],
    SM: [
        {
            col:"/src/assets/3dTestStuff/Egypt-Colour-SM",
        },
        {
            col:"/src/assets/3dTestStuff/Celtic-Colour-SM",
        },
        {
            col:"/src/assets/3dTestStuff/Ornate-Colour-SM",
        }
    ]
};
var ringImages;

export default {
    props: ["guid"],
    metaInfo: {
        title: 'Home',
        meta: [
            { name: 'description', content: 'The Artful Dodgers Ltd. Treat yourself! '},
            { property: 'og:title', content: 'Home | Artful Dodgers Ltd'},
            { property: 'og:site_name', content: 'Artful Dodgers'},
            { property: 'og:description', content: 'The Artful Dodgers Ltd. Treat yourself!'},
            { property: 'og:type', content: 'website'},
            { property: 'og:url', content: 'https://artfuldodgers.co.nz/'},
            { property: 'og:image', content: 'https://artfuldodgers.co.nz/assets/img/ad-trixy-ring.png'}
        ]
    },
    data: function() {
        return {
            currentIndex: 0,
            mainHeight: "calc(100vh - 150px);",
            minHeight: "790px;",
            touch: false,
            imagePrefix: ".webp",
            imagesSorted: false,
            maskVH: "673px"
        }
    },
    methods: {
        setUpTouch: function () {
            var self = this;
            document.addEventListener('touchstart', handleTouchStart, false);        
            document.addEventListener('touchmove', handleTouchMove, false);

            var xDown = null;                                                        
            var yDown = null;

            function getTouches(evt) {
            return evt.touches ||             // browser API
                    evt.originalEvent.touches; // jQuery
            }                                                     

            function handleTouchStart(evt) {
                const firstTouch = getTouches(evt)[0];                                      
                xDown = firstTouch.clientX;                                      
                yDown = firstTouch.clientY;                                      
            };             

            function handleTouchMove(evt) {
                if ( ! xDown || ! yDown ) {
                    return;
                }

                var xUp = evt.touches[0].clientX;                                    
                var yUp = evt.touches[0].clientY;

                var xDiff = xDown - xUp;
                var yDiff = yDown - yUp;

                if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*most significant*/
                    if ( xDiff > 0 ) {
                        /* left swipe */ 
                        self.goPrevious(evt);
                    } else {
                        self.goNext(evt);
                    }                       
                } else {
                    if ( yDiff > 0 ) {
                        /* up swipe */ 
                    } else { 
                        /* down swipe */
                    }                                                                 
                }
                /* reset values */
                xDown = null;
                yDown = null;                                             
            };
        },
        exitAnimation(){
            var self = this;
            var pageBtns = $(".c-2d__page-btns");
            var pagination = $(".c-2d__pagination");
            var exploreBtn = $(".t-flex-grid__title");
            var circles = $(".c-2d__loader");
            var overlay = $(".c-2d--dist");
            var canvas = $("#canvas");
            var vid = $('.c-2d__video');
            var image = $('.c-2d__main-image');

            $('.t-flex-grid__title').css("pointer-events","none");

            TweenMax.to(pageBtns, 0.25, {opacity:0});
            TweenMax.to(exploreBtn, 0.25, {opacity:0});
            TweenMax.to(vid, 0.5, {opacity:0});

            TweenMax.staggerTo(circles, 0.3, {strokeDashoffset:1759.292}, 0.01);
            
            TweenMax.fromTo($(".c-2d__page-number--center"), 1, {opacity:0.7, y:0,},{opacity:0, y:25, ease: Power1.easeOut});
            setTimeout(function(){
                TweenMax.fromTo($(".c-2d__page-number--edge"), 1, {opacity:1, y:0,},{opacity:0, y:25, ease: Power1.easeOut});
            }, 150)
            
            setTimeout(function(){
                TweenMax.to(overlay, 0.3, {opacity:1});
                TweenMax.to(overlay, 1, {maskSize:"140vh", webkitMaskSize:"140vh"});
                TweenMax.to(self.dispFactor, 1, {value:self.dispFactor - 0.1});

                setTimeout(function(){
                    TweenMax.to(self.dispFactor, 0.7, {value:0});
                    TweenMax.to(overlay, 0.5, {opacity:0});

                    if (self.touch) {
                        TweenMax.to(image, 0.5, {opacity:0})
                    } else {
                        TweenMax.to(canvas, 0.5, {opacity:0})
                    }
                }, 150)
            }, 100)
        },
        enterAnimation(){
            var self = this;

            var thousand = self.touch ? 500 : 1000;
            var sevenHundred = self.touch ? 350 : 700;
            var fiveHundred = self.touch ? 250 : 500;
            var threeHundred = self.touch ? 150 : 300;

            var $outRing = $(".c-2d--dist");
            var mainCanvas = $("#canvas");
            var exploreBtn = $(".t-flex-grid__title");
            var pageBtns = $(".c-2d__page-btns");
            var vid = $('.c-2d__video');
            var image = $('.c-2d__main-image');

            var outerRing = .9;
            var innerRing = 0.62;
            var sevenninety = window.matchMedia('(min-width: 790px)');
            if (sevenninety.matches) {
                var outerRing = 1.21;
                var innerRing = 0.83;
            }
            
            if (self.touch) {
                TweenMax.to(image, 2, {opacity:1, ease:Power1.easeInOut})
            } else {
                TweenMax.to(mainCanvas, 2, {opacity:1, ease:Power1.easeInOut})
            }
            if (document.querySelector('video')){
                var playPromise = document.querySelector('video').play();
                TweenMax.to(vid, 1, {opacity:1});
            }

            setTimeout(function(){
                if (self.dispFactor != null){
                    TweenMax.fromTo(self.dispFactor, 16, {value:0.2}, {
                        value: .99,
                        repeat: -1,
                        yoyo: true,
                        repeatDelay:0,
                        ease:Power1.easeOut
                    });
                }

                TweenMax.to($outRing, 1.5, {opacity:0.7});
                TweenMax.fromTo($outRing, 2, {maskSize:"104vh", webkitMaskSize:"104vh"}, {maskSize:self.maskVH, webkitMaskSize:self.maskVH, ease:Power1.easeOut});
                TweenMax.fromTo($("#svg-circle-outer"), 2, {scale:outerRing * 1.4},  {scale:outerRing, ease:Power1.easeOut})
                TweenMax.fromTo($("#svg-circle-outer-left"), 2, {scale:outerRing * -1.4},  {scale:outerRing * -1, ease:Power1.easeOut})

                TweenMax.fromTo($("#svg-circle-inner"), 2, {scale:innerRing * 1.45, x:-3},  {scale:innerRing, x:-3, ease:Power1.easeOut})
                TweenMax.fromTo($("#svg-circle-inner-left"), 2, {scale:innerRing * -1.45, x:-3},  {scale:innerRing * -1, x:-3, ease:Power1.easeOut})

                setTimeout(function(){
                    
                    TweenMax.to($(".c-2d__loader"), 9, {strokeDashoffset:0, ease:Power2.easeOut})
                    TweenMax.to($("#svg-circle-outer"), 9, {rotation:720, ease:Power2.easeOut})
                    TweenMax.fromTo($("#svg-circle-outer--left"), 9, {rotation:-180}, {rotation:-360, ease:Power2.easeOut, yoyo:true})

                    TweenMax.to($("#svg-circle-inner"), 9, {rotation:-720, ease:Power2.easeOut, yoyo:true})
                    TweenMax.fromTo($("#svg-circle-outer--left"), 9, {rotation:-180}, {rotation:-1080, ease:Power2.easeOut})

                    setTimeout(function(){
                        TweenMax.fromTo($(".c-2d__page-number--center"), 2, {opacity:0, y:25,},{opacity:0.7, y:0, ease: Power1.easeOut});
                        
                        TweenMax.to(pageBtns, 0, {opacity:1});
                        TweenMax.to(exploreBtn, 0.8, {opacity:0.75});
                        TweenMax.fromTo($(".c-2d__page-btn--prev"), 1.5, {opacity:0, x:0}, {opacity:0.8, x:-45, ease: Power2.easeOut});
                        TweenMax.fromTo($(".c-2d__page-btn--next"), 1.5, {opacity:0, x:0}, {opacity:0.8, x:45, ease: Power2.easeOut});
                        setTimeout(function(){
                            $('.t-flex-grid__title').css("pointer-events","all");
                            TweenMax.fromTo($(".c-2d__page-number--edge"), 2, {opacity:0, y:25,},{opacity:1, y:0, ease: Power1.easeOut});
                        }, threeHundred)
                    }, fiveHundred)
                }, sevenHundred)
            }, thousand)
        },
        firstAnimation(){
            var self = this;

            var $outRing = $(".c-2d--dist");
            var mainCanvas = $("#canvas");
            var exploreBtn = $(".t-flex-grid__title");
            var pageBtns = $(".c-2d__page-btns");
            var vid = $('.c-2d__video');
            var image = $('.c-2d__main-image');

            var outerRing = .9;
            var innerRing = 0.62;
            var sevenninety = window.matchMedia('(min-width: 790px)');
            if (sevenninety.matches) {
                var outerRing = 1.21;
                var innerRing = 0.83;
            }
            
            if (self.touch) {
                TweenMax.to(image, 2, {opacity:1, ease:Power1.easeInOut})
            } else {
                TweenMax.to(mainCanvas, 2, {opacity:1, ease:Power1.easeInOut})
            }
            if (document.querySelector('video')){
                var playPromise = document.querySelector('video').play();
                if (playPromise !== undefined) {
                    playPromise.then(function() {
                        // Automatic playback started!
                        TweenMax.to(vid, 1, {opacity:1});
                    }).catch(function(error) {
                        TweenMax.to(vid, 1, {opacity:0});
                        // Automatic playback failed.
                        // Show a UI element to let the user manually start playback.
                    });
                }
            }

            setTimeout(function(){
                if (self.dispFactor != null){
                    TweenMax.fromTo(self.dispFactor, 16, {value:0.2}, {
                        value: .99,
                        repeat: -1,
                        yoyo: true,
                        repeatDelay:0,
                        ease:Power1.easeOut
                    });
                }

                TweenMax.to($outRing, 1.5, {opacity:0.7});



                TweenMax.fromTo($outRing, 2, {maskSize:"104vh", webkitMaskSize:"104vh"}, {maskSize:self.maskVH, webkitMaskSize:self.maskVH, ease:Power1.easeOut});
                TweenMax.fromTo($("#svg-circle-outer"), 2, {scale:outerRing * 1.4},  {scale:outerRing, ease:Power1.easeOut})
                TweenMax.fromTo($("#svg-circle-outer-left"), 2, {scale:outerRing * -1.4},  {scale:outerRing * -1, ease:Power1.easeOut})

                TweenMax.fromTo($("#svg-circle-inner"), 2, {scale:innerRing * 1.45, x:-3},  {scale:innerRing, x:-3, ease:Power1.easeOut})
                TweenMax.fromTo($("#svg-circle-inner-left"), 2, {scale:innerRing * -1.45, x:-3},  {scale:innerRing * -1, x:-3, ease:Power1.easeOut})

                setTimeout(function(){
                    
                    TweenMax.to($(".c-2d__loader"), 9, {strokeDashoffset:0, ease:Power2.easeOut})
                    TweenMax.to($("#svg-circle-outer"), 9, {rotation:720, ease:Power2.easeOut})
                    TweenMax.fromTo($("#svg-circle-outer--left"), 9, {rotation:-180}, {rotation:-360, ease:Power2.easeOut, yoyo:true})

                    TweenMax.to($("#svg-circle-inner"), 9, {rotation:-720, ease:Power2.easeOut, yoyo:true})
                    TweenMax.fromTo($("#svg-circle-outer--left"), 9, {rotation:-180}, {rotation:-1080, ease:Power2.easeOut})

                    setTimeout(function(){
                        TweenMax.fromTo($(".c-2d__page-number--center"), 2, {opacity:0, y:25,},{opacity:0.7, y:0, ease: Power1.easeOut});
                        
                        TweenMax.to(pageBtns, 0, {opacity:1});
                        TweenMax.to(exploreBtn, 0.8, {opacity:0.75});
                        TweenMax.fromTo($(".c-2d__page-btn--prev"), 3, {opacity:0, x:0}, {opacity:0.8, x:-45, ease: Power2.easeOut});
                        TweenMax.fromTo($(".c-2d__page-btn--next"), 3, {opacity:0, x:0}, {opacity:0.8, x:45, ease: Power2.easeOut});
                        setTimeout(function(){
                            $('.t-flex-grid__title').css("pointer-events","all");
                            TweenMax.fromTo($(".c-2d__page-number--edge"), 2, {opacity:0, y:25,},{opacity:1, y:0, ease: Power1.easeOut});
                        }, 300)
                    }, 1000)
                }, 700)
            }, 1000)
        },
        switchThree: function(){
            var self = this;

            if (!self.touch) {
                let originalImage = { width: 1, height: 1 }; // replaced after loading
                var originalTexture = twgl.createTexture(self.gl, {
                src: self.ringImages[self.currentIndex].col, 
                    crossOrigin: '',
                }, (err, texture, source) => {
                    originalImage = source;
                });
                self.originalTexture = originalTexture;
                
                var mapTexture = twgl.createTexture(self.gl, {
                    src: self.ringImages[self.currentIndex].z, crossOrigin: '',
                });
                self.mapTexture = mapTexture;
            } else {
                $('.c-2d__main-image').css("background-image","url(" + self.ringImages[self.currentIndex].col + ")");
            }
        },
        goNext(event) {
            event.preventDefault();
            var self = this;
            var switchTime = self.touch ? 900 : 1150;

            if (self.currentIndex == 2) {
                self.currentIndex = 0;
            } else {
                self.currentIndex++;
            }

            if (self.touch) {
                $(".c-2d__main-image").css("transform", "scale(0.8)");
                $(".c-2d__main-image").css("opacity", "0");
            } else {
                $("#canvas").css("transform", "scale(0.8)");
                // $("#canvas").css("height", "calc(80vh - 150px)");
                // $("#canvas").css("min-height", self.minHeight);
            }
            self.exitAnimation();
            setTimeout(function(){
                self.switchThree();
                setTimeout(function(){
                    if (self.touch) {
                        $(".c-2d__main-image").css("transform", "scale(1)");
                        $(".c-2d__main-image").css("opacity", "1");
                    }

                    self.enterAnimation();
                    $("#canvas").css("transition", "transform 4.5s cubic-bezier(0, 0, 0.54, 0.96), opacity 0.35s cubic-bezier(0, 0, 0.54, 0.96)");
                    $("#canvas").css("height", self.mainHeight);
                    $("#canvas").css("min-height", self.minHeight);
                    if (!self.touch) {
                        setTimeout(function(){
                            $("#canvas").css("transform", "scale(1)");
                        }, 350)
                    }
                }, 300)
            }, switchTime)
        },
        goPrevious() {
            event.preventDefault();
            var self = this;
            var switchTime = self.touch ? 900 : 1150;

            if (self.currentIndex == 0) {
                self.currentIndex = 2;
            } else {
                self.currentIndex--;
            }
            

            if (self.touch) {
                $(".c-2d__main-image").css("transform", "scale(.8)");
                $(".c-2d__main-image").css("opacity", "0");
            } else {
                $("#canvas").css("transform", "scale(0.85)");
            }

            self.exitAnimation();
            setTimeout(function(){
                self.switchThree();

                if (self.touch) {
                    $(".c-2d__main-image").css("transform", "scale(1)");
                    $(".c-2d__main-image").css("opacity", "1");
                } 
                setTimeout(function(){
                    self.enterAnimation();
                    $("#canvas").css("transition", "transform 3s cubic-bezier(0, 0, 0.54, 0.96), opacity 0.35s cubic-bezier(0, 0, 0.54, 0.96)");
                    $("#canvas").css("height", self.mainHeight);
                    $("#canvas").css("min-height", self.minHeight);
                    if (!self.touch) {
                        setTimeout(function(){
                            $("#canvas").css("transform", "scale(1)");
                        }, 350)
                    }
                }, 300)
            }, switchTime)
        },
        animateHome(){
            this.enterAnimation();
        }
    },
    mounted: function(){
        var self = this;
        if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1){
            self.maskVH = "673px";    
        }
        var waitToLoad = setInterval(function() {
            if (self.$parent.initLoad && self.imagesSorted) {
                $('.c-2d__main-image').css("background-image","url(" + self.ringImages[self.currentIndex].col + ")");
                self.firstAnimation();
                clearInterval(waitToLoad);
            }
        }, 10)
    },
    created() {
        var self = this;

        var isIE = /*@cc_on!@*/false || !!document.documentMode;

        if (Modernizr.touchevents || isIE) {
            self.touch = true;
        } else {
            self.touch = false;
        }


        self.ringImages = ringImagesAll.SM;
        if (window.matchMedia("(min-width:610px)").matches) {
            self.ringImages = ringImagesAll.MD;
        }
        if (window.matchMedia("(min-width:1366px)").matches) {
            self.ringImages = ringImagesAll.LG;
        }
        if (self.ringImages[0].col.indexOf("webp") == -1 && self.ringImages[0].col.indexOf("png") == -1) {
            Modernizr.on('webp', function(result) {
                if (result) {
                    self.ringImages.forEach(element => {
                        element.col += ".webp";
                        element.z += ".webp";
                    });
                } else {
                    self.ringImages.forEach(element => {
                        element.col += ".png";
                        element.z += ".png";
                    });
                }
            })
        }
        self.imagesSorted = true;

        // ONLY JQ at the moment. Could possibly remove;
    $(document).ready(function() {
        "use strict";
        window.mobileHompage = function(){
            self.firstAnimation();
        }

        "use strict";
        window.homePage = function () {
            // Get A WebGL context
            /** @type {HTMLCanvasElement} */

            var displaceVertex = `
                varying vec2 vUv;
                void main() {
                vUv = uv;
                gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
                }
            `;

            var displaceFragment = `
                varying vec2 vUv;

                uniform sampler2D texture;
                uniform sampler2D texture2;
                uniform sampler2D disp;

                // uniform float time;
                // uniform float _rot;
                uniform float dispFactor;
                uniform float effectFactor;

                // vec2 rotate(vec2 v, float a) {
                //  float s = sin(a);
                //  float c = cos(a);
                //  mat2 m = mat2(c, -s, s, c);
                //  return m * v;
                // }

                void main() {

                    vec2 uv = vUv;

                    // uv -= 0.5;
                    // vec2 rotUV = rotate(uv, _rot);
                    // uv += 0.5;

                    vec4 disp = texture2D(disp, uv);

                    vec2 distortedPosition = vec2(uv.x - dispFactor * (disp.r*effectFactor), uv.y + dispFactor * (disp.r*effectFactor));
                    vec2 distortedPosition2 = vec2(uv.x + (1.0 - dispFactor) * (disp.r*effectFactor), uv.y - (1.0 - dispFactor) * (disp.r*effectFactor));

                    vec4 _texture = texture2D(texture, distortedPosition);
                    vec4 _texture2 = texture2D(texture2, distortedPosition2);

                    vec4 finalTexture = mix(_texture, _texture2, dispFactor);

                    gl_FragColor = finalTexture;
                    // gl_FragColor = disp;
                }
            `;
            //DISTORTION FILTER
            var parent = $("#overlay")[0];

            var scene = new THREE.Scene();
            var camera = new THREE.OrthographicCamera(
                parent.offsetWidth / -2,
                parent.offsetWidth / 2,
                parent.offsetHeight / 2,
                parent.offsetHeight / -2,
                1,
                1000
            );
            camera.position.z = 1;

            var renderer = new THREE.WebGLRenderer({
                antialias: false,
                // alpha: true
            });

            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setClearColor(0xffffff, 0.0);
            renderer.setSize(parent.offsetWidth, parent.offsetHeight);
            parent.appendChild(renderer.domElement);
            
            var loader = new THREE.TextureLoader();
            loader.crossOrigin = "";

            var texture1;;
            var displacementMapLocation = "../assets/img/displacement/6.webp";
            if (document.head.parentElement.classList.contains("no-webp")) {
                texture1 = loader.load("/src/assets/3dTestStuff/Egypt-Colour-LG.png");
                displacementMapLocation = "../assets/img/displacement/6.png";
            } else {
                texture1 = loader.load("/src/assets/3dTestStuff/Egypt-Colour-LG.webp");
            }
            texture1.minFilter = THREE.NearestFilter;
            var disp = loader.load(displacementMapLocation);
            disp.wrapS = disp.wrapT = THREE.RepeatWrapping;

            texture1.anisotropy = renderer.capabilities.getMaxAnisotropy();
            
            var mat = new THREE.ShaderMaterial({
                uniforms: {
                    effectFactor: { type: "f", value: -0.65 },
                    dispFactor: { type: "f", value: 0.0 },
                    texture: { type: "t", value: texture1 },
                    texture2: { type: "t", value: texture1 },
                    disp: { type: "t", value: disp }
                },

                vertexShader: displaceVertex,
                fragmentShader: displaceFragment,
                transparent: true,
                opacity: 1.0
            });
            // mat.defaultAttributeValues.uv = [1, 0];
            // mat.defaultAttributeValues.uv2 = [1, 0];

            var geometry = new THREE.PlaneBufferGeometry(
                parent.offsetWidth,
                parent.offsetHeight
            );

            const canvasAspect = parent.offsetWidth / parent.offsetHeight;
            const imageAspect = 3000 / 1440;

            let horizontalDrawAspect = imageAspect / canvasAspect;
            let verticalDrawAspect = 1;
            // does it fill horizontally?
            if (horizontalDrawAspect < 1) {
                // no it does not so scale so we fill horizontally and
                // adjust vertical to match
                verticalDrawAspect /= horizontalDrawAspect;
                horizontalDrawAspect = 1;
            }

            var object = new THREE.Mesh(geometry, mat);
            object.scale.x = horizontalDrawAspect;
            object.scale.y = verticalDrawAspect;
            scene.add(object);

            self.dispFactor = mat.uniforms.dispFactor;

            TweenMax.to(mat.uniforms.dispFactor, 50, {
                value: 1,
                yoyo: true,
                ease: Power3.easeOut
            });


        $('.c-2d').each(function(i, canvas){
            //Mapped 3D
            Modernizr.on('webp', function(result) {     

                self.gl = canvas.getContext("webgl");
                if (!self.gl) {
                    return;
                }

                twgl.setDefaults({
                    textureColor: [0, 0, 0, 0],  // make initial color transparent black
                });

                self.originalImage = { width: 1, height: 1 }; // replaced after loading
                self.originalTexture = twgl.createTexture(self.gl, {
                src: self.ringImages[self.currentIndex].col, 
                    crossOrigin: '',
                }, (err, texture, source) => {
                    self.originalImage = source;
                });
                
                if (self.ringImages[self.currentIndex].z == "undefined.webp") {
                    self.ringImages[self.currentIndex].z = "/src/assets/3dTestStuff/Egypt-Z-LG" + self.imagePrefix;
                }

                self.mapTexture = twgl.createTexture(self.gl, {
                    src: self.ringImages[self.currentIndex].z, crossOrigin: '',
                });

                // compile shaders, link program, lookup location
                self.programInfo = twgl.createProgramInfo(self.gl, ["vs", "fs"]);

                // calls gl.createBuffer, gl.bindBuffer, gl.bufferData for a quad
                self.bufferInfo = twgl.primitives.createXYQuadBufferInfo(self.gl);

                self.mouse = [0, 0];
                
                var posLeft = $(self.gl.canvas).width() * i;

                document.addEventListener('mousemove', (event) => {
                    if (event.clientX > posLeft && event.clientX < posLeft + $(self.gl.canvas).width()){
                        self.mouse[0] = ((event.clientX - posLeft) / self.gl.canvas.clientWidth * 2 - 1) * -0.02;
                        self.mouse[1] = (event.clientY / self.gl.canvas.clientHeight * 2 - 1) * -0.04;
                    }
                });
                
                document.addEventListener('touchmove', (event) => {
                    self.mouse[0] = ((event.touches[0].clientX - + posLeft) / self.gl.canvas.clientWidth * 2 - 1) * -0.02;
                    self.mouse[1] = (event.touches[0].clientY / self.gl.canvas.clientHeight * 2 - 1) * -0.04;
                });
                    
                document.addEventListener('touchend', (event) => {
                    self.mouse[0] = 0;
                    self.mouse[1] = 0;
                });
                    
                self.nMouse = [0, 0];
                self.oMouse = [0, 0];
            
                var animate = function() {
                requestAnimationFrame(animate);

                renderer.render(scene, camera);
                };
                animate();

                requestAnimationFrame(render);


                window.addEventListener("resize", function(e) {
                    renderer.setSize(parent.offsetWidth, parent.offsetHeight);
                });



                function render() {
          
                    twgl.resizeCanvasToDisplaySize(self.gl.canvas);

                    self.gl.viewport(0, 0, self.gl.canvas.width, self.gl.canvas.height);

                    self.gl.clearColor(0, 0, 0, 0);
                    self.gl.clear(self.gl.COLOR_BUFFER_BIT);

                    self.gl.useProgram(self.programInfo.program);

                    // calls gl.bindBuffer, gl.enableVertexAttribArray, gl.vertexAttribPointer
                    twgl.setBuffersAndAttributes(self.gl, self.programInfo, self.bufferInfo);
            

                    const canvasAspect = self.gl.canvas.clientWidth / self.gl.canvas.clientHeight;
                    const imageAspect = self.originalImage.width / self.originalImage.height;

                    let scaleY = 1;
                    let scaleX = imageAspect / canvasAspect;
                    if (scaleX < 1) {
                        scaleY = 1 / scaleX;
                        scaleX = 1;
                    }
                    const mat = m3.scaling(imageAspect / canvasAspect, -1);
                        
                    self.nMouse[0] += (self.mouse[0] - self.nMouse[0]) * .2;
                    self.nMouse[1] += (self.mouse[1] - self.nMouse[1]) * .2;
                            
                    // calls gl.activeTexture, gl.bindTexture, gl.uniformXXX
                    twgl.setUniforms(self.programInfo, {
                        u_matrix: mat,
                        u_originalImage: self.originalTexture,
                        u_mapImage: self.mapTexture,
                        u_mouse: self.nMouse,
                    });
                        
                    // calls gl.drawArrays or gl.drawElements
                    twgl.drawBufferInfo(self.gl, self.bufferInfo);
                    
                    requestAnimationFrame(render);
                    
                }
            }); 
            })
        
        }
        if (!self.touch) {
            homePage();
        } else {
            self.setUpTouch();
        }
    }); 

        //HANDLE VIDEO
        var waitToLoadVid = setInterval(function() {
            if (document.querySelector('video')) {
                var playPromise = document.querySelector('video').play();
                // In browsers that don’t yet support this functionality,
                if (playPromise !== undefined) {
                playPromise.then(function() {
                    // Automatic playback started!
                }).catch(function(error) {
                    console.log("error ", error);
                    // Automatic playback failed.
                    // Show a UI element to let the user manually start playback.
                    });
                }
                clearInterval(waitToLoadVid);
            }
        }, 100)

        var supportsWebMAlpha = function(callback)
        {
            var vid = document.createElement('video');
            vid.autoplay = false;
            vid.loop = false;
            vid.style.display = "none";
            vid.addEventListener("loadeddata", function()
            {
                document.body.removeChild(vid);
                // Create a canvas element, this is what user sees.
                var canvas = document.createElement("canvas");

                //If we don't support the canvas, we definitely don't support webm alpha video.
                if (!(canvas.getContext && canvas.getContext('2d')))
                {
                    callback(false);
                    return;
                }

                // Get the drawing context for canvas.
                var ctx = canvas.getContext("2d");

                // Draw the current frame of video onto canvas.
                ctx.drawImage(vid, 0, 0);
                if (ctx.getImageData(0, 0, 1, 1).data[3] === 0)
                {
                    callback(true);
                }
                else
                {
                    callback(false);
                }

            }, false);
            vid.addEventListener("error", function()
            {
                document.body.removeChild(vid);
                callback(false);
            });

            vid.addEventListener("stalled", function()
            {
                document.body.removeChild(vid);
                callback(false);
            });

            //Just in case
            vid.addEventListener("abort", function()
            {
                document.body.removeChild(vid);
                callback(false);
            });

            var source = document.createElement("source");
            source.src="data:video/webm;base64,GkXfowEAAAAAAAAfQoaBAUL3gQFC8oEEQvOBCEKChHdlYm1Ch4ECQoWBAhhTgGcBAAAAAAACBRFNm3RALE27i1OrhBVJqWZTrIHlTbuMU6uEFlSua1OsggEjTbuMU6uEHFO7a1OsggHo7AEAAAAAAACqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAVSalmAQAAAAAAADIq17GDD0JATYCNTGF2ZjU3LjU3LjEwMFdBjUxhdmY1Ny41Ny4xMDBEiYhARAAAAAAAABZUrmsBAAAAAAAARq4BAAAAAAAAPdeBAXPFgQGcgQAitZyDdW5khoVWX1ZQOYOBASPjg4QCYloA4AEAAAAAAAARsIFAuoFAmoECU8CBAVSygQQfQ7Z1AQAAAAAAAGfngQCgAQAAAAAAAFuhooEAAACCSYNCAAPwA/YAOCQcGFQAADBgAABnP///NXgndmB1oQEAAAAAAAAtpgEAAAAAAAAk7oEBpZ+CSYNCAAPwA/YAOCQcGFQAADBgAABnP///Vttk7swAHFO7awEAAAAAAAARu4+zgQC3iveBAfGCAXXwgQM=";
            source.addEventListener("error", function()
            {
            document.body.removeChild(vid);
            callback(false);
            });
            vid.appendChild(source);

            //This is required for IE
            document.body.appendChild(vid);
        };

        supportsWebMAlpha(function(result)
        {
        if (!result)
            {
                $("#video1").remove();
            }
        });
    }// END CREATED
}
</script>


// WEBPACK FOOTER //
// ThreeD.vue?69f1db84